import React from "react";
import PropTypes from "prop-types";
import Modal from 'react-modal';
import { Line } from 'rc-progress';
import FaYoutube from "react-icons/lib/fa/youtube"; // TODO - update react icons to version 3 so I can use the correct icon
import { addAllToPlaylist, cancelAddAllToPlaylist, viewOnYoutube, promiseCreatePlaylist } from '../../lib/youtube-converter';
import { isMobileOrTablet, windowOpen, localStorageSet, localStorageGet  } from '../../lib/window';


const customStyles = {
  overlay: {zIndex: 10},
  content : {
    top                   : '50%',
    left                  : '50%',
    right                 : 'auto',
    bottom                : 'auto',
    marginRight           : '-50%',
    transform             : 'translate(-50%, -50%)'
  }
};

class PlaylistConversionModal extends React.Component {
  constructor() {
    super();

    this.state = {
      modalIsOpen: false,
      playlistId: '',
      progress: 0,
      songsLength: 0,
      index: 0
    };

    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.closeModalAndCancel = this.closeModalAndCancel.bind(this);
    this.updateProgress = this.updateProgress.bind(this);
  }

  openModal(songs, title) {
    let songsLimit = songs.slice(0, 250);

    // Do a progress bar and make sure this only runs once
    promiseCreatePlaylist(title).then((response) => {
      if (response.success) {
        const { playlist } = response.success;
        this.setState({ playlistId: playlist.id });


        addAllToPlaylist(songsLimit, playlist.id, this.updateProgress, {});
      } else {
        if (response.error) {
          const { message } = response.error;
        }
      }
    });
    this.setState({ modalIsOpen: true, playlistId: '', progress: 0, songsLength: songsLimit.length });
  }

  closeModalAndCancel() {
    cancelAddAllToPlaylist();
    this.setState({modalIsOpen: false, progress: 0, playlistId: '', songsLength: 0, index: 0});
  }

  closeModal() {
    // cancelAddAllToPlaylist();
    this.setState({modalIsOpen: false, progress: 0, playlistId: '', songsLength: 0, index: 0});
  }

  updateProgress(index) {
    const percent = (100 * index) / this.state.songsLength;
    const progress = Math.ceil(percent);
    // make sure it's an int value

    this.setState({ progress, index });
  }

  render() {
    const { canConvert, songs, title } = this.props;
    const { playlistId, progress, index } = this.state;

    const viewOnYoutube = () => {
      windowOpen('https://www.youtube.com/playlist?list=' + playlistId);
    };
    const done = progress === 100;

    customStyles.content.height = isMobileOrTablet() ? '90vh' : '70vh';
    customStyles.content.width = isMobileOrTablet() ? '90vw' : '70vw';

    return (
      <React.Fragment>
        <div className="playlist-conversion-modal">
          {canConvert && <button className="convert-playlist md" onClick={() => this.openModal(songs, title)}>Convert Playlist</button>}
          <Modal
            ariaHideApp={false}
            isOpen={this.state.modalIsOpen}
            // onAfterOpen={this.afterOpenModal}
            // onRequestClose={this.closeModal}
            style={customStyles}
            contentLabel="Example Modal"
            >
            <div>
              <h2>{title} - Converting Spotify Playlist to YouTube</h2>
              <br />
              <h4>{ progress }% Done, {index} of {songs.length}
                <a target="_blank" href="https://www.youtube.com/channel/UCNnkp6SwIbCXXOmXZzoDEJA?sub_confirmation=1"><h3>Follow Playlist Buddy on YouTube</h3></a>
              </h4>
              <Line percent={progress} strokeWidth={isMobileOrTablet() ? 3 : 1} strokeColor="#346294" />
              <br />
              <a target="_blank" style={{"color": "red"}} href="/quota-playlist-buddy/">
                Playlist Conversion temporarily limited to 250 songs
              </a>
              <br />
              {!isMobileOrTablet() &&
                <div>
                  <br />
                  <a target="_blank" href="https://www.tunemymusic.com/YouTube-to-Spotify.php">Convert YouTube to Spotify</a><br /><br />
                  <a target="_blank" href="/airbnb-credit/">Sign up for AirBnb - $55 free</a><br />
                  <a target="_blank" href="http://youtube.com/c/shervinater">Learn about Smart Health Technology / Biohacking</a><br />
                  {/*<a target="_blank" href="https://www.amazon.com/gp/product/B00V9Z2WBK/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=B00V9Z2WBK&linkCode=as2&tag=santabarbar0a-20&linkId=7ea2b55262c2a97481e817412aaee40a"><img border={0} src="//ws-na.amazon-adsystem.com/widgets/q?_encoding=UTF8&MarketPlace=US&ASIN=B00V9Z2WBK&ServiceVersion=20070822&ID=AsinImage&WS=1&Format=_SL250_&tag=santabarbar0a-20" /></a><img src="//ir-na.amazon-adsystem.com/e/ir?t=santabarbar0a-20&l=am2&o=1&a=B00V9Z2WBK" width={1} height={1} border={0} alt style={{'border': 'none !important', 'margin': '0px !important'}} />*/}
                  {/*<div>I personally own these speakers. They are amazing!! Please buy some to support Playlist Buddy! The referral link here charges the same and your purchase helps keep Playlist Buddy free.</div>*/}
                </div>
              }

              {/*<h4>Please take this survey to help determine the price to charge for Playlist Buddy</h4>*/}
              {/*<a target="_blank" style={{"color": "blue"}} href="https://www.surveymonkey.com/r/YR93TKS">Pricing Survey - What's a fair price?</a>*/}
              {/*<br />*/}
              <div className="bottom-right">
                {!done && <button className="cancel-conversion xl" onClick={this.closeModalAndCancel}>Cancel Conversion</button>}
                {done && <button className="cancel-conversion xl" onClick={this.closeModal}>Close Modal</button>}
                {playlistId && <button className="view-on-youtube xl" onClick={viewOnYoutube}>View on YouTube</button>}
              </div>
            </div>
          </Modal>
        </div>

        {/* --- STYLES --- */}
        <style jsx>{`
          .playlist-conversion-modal {
            display: inline-block;
            margin-left: 10px;
          }

          button {
            border: 0;
            cursor: pointer;
            font-size: 16px;
            min-width: 100px;
          }

          button.xl {
            border-radius: 5px;
            font-size: 24px;
            padding: 10px 15px;
          }

          .bottom-right {
            position: absolute;
            right: 10px;
            bottom: 10px;
          }

          button.cancel-conversion {

          }

          button.md {
            border-radius: 5px;
            // font-size: px;
            padding: 10px 15px;
          }

          button.convert-playlist {
            background: #346294;
            color: white;
          }

          button.view-on-youtube {
            background: red;
            color: white;
            // border-radius: 50px;
            // max-width: 100vw;
            min-height: 60px;
            margin-left: 20px;

            &[disabled] {
              background: gray;
            }
          }

          @from-width tablet {
            .playlist-conversion-modal {

            }
          }
        `}</style>
      </React.Fragment>
    );
  }
};

export default PlaylistConversionModal;



// WEBPACK FOOTER //
// ./src/components/PlaylistConversionModal/PlaylistConversionModal.js